<template>
  <page-view title="Developer">
    <div class="d-f fd-c fd-md-r f-g">
      <card-link to="/developer/logs" title="API request logs" text="View API request logs." backgroundColor="#B1E3FF"></card-link>
      <card-link to="https://developer.streamify.io" target="_blank" title="Explore API documentation" text="Review the documentation and integration guide to get started." backgroundColor="#606D74"></card-link>
    </div>
  </page-view>
</template>

<script>
export default {
};
</script>
